import { Component } from 'opus-angular-seed-core';

// Default detail form for all triggers EXCEPT CERTIFICATE_EXPIRING.
// Renders everything below the Trigger/Action selectors for non-CERT triggers.
@Component({
    bindings: {
        form: '=',            // parent form object (with model, errors)
        activetype: '=',      // currently active moduleType
        enums: '<',           // { COMPANY_LANGUAGE_ENUM, OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM, COURSE_TRAINING_TYPE_ENUM }
        defaultLanguage: '<', // company's default language
        helpers: '<',         // parent helper methods (preview, getVariables, etc.)
        ckconfig: '<'         // CKEditor config
    },
    template: `
        <div>
            <div ng-if="vm.form.model.action==='SEND_INDIVIDUAL_NOTIFICATIONS'">
                <h3>{{ 'courses.Training type' | translate }}</h3>
                <ul class="tabs01">
                    <li ng-repeat="template in vm.form.model.templates" ng-if="vm.helpers.isModuleEnabled(template.moduleType) && template.moduleType !== 'default'">
                        <span ng-class="{ active: vm.activetype==template.moduleType, enabled: template.isEnabled==true }">
                            <a ng-click="vm.activetype=template.moduleType">{{ vm.enums.COURSE_TRAINING_TYPE_ENUM.LABELS[template.moduleType] }}</a>
                        </span>
                    </li>
                </ul>
            </div>

            <div ng-repeat="(index, template) in vm.form.model.templates" ng-if="vm.activetype==template.moduleType && vm.helpers.isModuleEnabled(template.moduleType)">
                <div class="row" ng-if="vm.form.model.action==='SEND_INDIVIDUAL_NOTIFICATIONS'">
                    <span class="label">{{ 'general.Enabled' | translate }}</span>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox" ng-model="template.isEnabled" name="switch">
                            <span>Yes</span>
                        </label>
                    </div>
                </div>

                <div class="row" ng-if="template.isEnabled">
                    <span class="label">{{ 'notification.Send iCal file' | translate }}</span>
                    <div class="items">
                        <label class="switch01">
                            <input type="checkbox" ng-model="template.sendIcalFile" name="switch">
                            <span>Yes</span>
                        </label>
                    </div>
                </div>

                <div class="alert alert-plain" ng-if="template.isEnabled">
                    <p>{{ 'events.Notification text, that will be sent to employee as an e-mail.' | translate }}</p>
                    <ul>
                        <li ng-repeat="item in vm.helpers.getVariables(template)">{{ vm.helpers.getTag(item) }}</li>
                    </ul>
                </div>

                <div class="row" ng-if="template.isEnabled">
                    <label class="label">{{ 'events.Recipient' | translate }}</label>
                    <div class="items">
                        <ul class="checkboxes">
                            <li>
                                <label>
                                    <input type="radio" ng-checked="true" value="RELATED_EMPLOYEE" name="recipient">
                                    <span>{{ 'events.Related employee' | translate }}</span>
                                </label>
                            </li>
                        </ul>
                    </div>
                </div>

                <form-row ng-if="vm.form.model.trigger==='EMPLOYEE_HAS_NOT_PASSED_TRAINING_MODULE' && template.isEnabled">
                    <label class="label">{{ 'events.Reminder send time' | translate }}</label>
                    <div class="items">
                        <table class="dnd">
                            <colgroup>
                                <col width="99%"/>
                                <col width="1%"/>
                            </colgroup>
                            <tbody>
                            <tr ng-repeat="(i, item) in template.times">
                                <td>
                                    <input type="number"
                                           min="0"
                                           step="1"
                                           class="form-control small02"
                                           ng-model="item.interval"
                                           ng-model-options="{ allowInvalid: true }"
                                           ng-change="vm.helpers.onIntervalChange(item)"
                                           ng-keydown="vm.helpers.preventNonNumeric($event)">
                                    <select ng-model="item.intervalType"
                                            ng-focus="vm.remindertime=true"
                                            class="form-control small02"
                                            ng-change="vm.helpers.clampReminder(item)">
                                        <option value="DAY">{{ vm.enums.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.DAY }}</option>
                                        <option value="WEEK">{{ vm.enums.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.WEEK }}</option>
                                        <option value="MONTH">{{ vm.enums.OCCURRENCE_ACCESS_PERIOD_TYPE_ENUM.LABELS.MONTH }}</option>
                                    </select>
                                    <select ng-model="item.type" ng-focus="vm.remindertime=true" class="form-control small">
                                        <option value="BEFORE_TRAINING_DEADLINE">{{ 'events.Before training deadline' | translate }}</option>
                                        <option ng-if="template.moduleType!=='ONLINE'" value="BEFORE_TRAINING_START">{{ 'events.Before training start' | translate }}</option>
                                    </select>
                                    <a ng-if="i!==0" ng-click="vm.helpers.deleteTime(i, template.times)" class="btn delete">{{ 'general.Delete' | translate }}</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <a class="btn main small" ng-click="vm.helpers.addNewTime(template.times)">{{ 'events.Add new time' | translate }}</a>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>

                <div ng-if="template.isEnabled" class="block02" ng-class="{ open: templateI18n.status === 'ACTIVE' }" ng-repeat="templateI18n in vm.helpers.getSortedLanguages(template.templateI18ns)">
                    <div class="heading01 heading01b">
                        <label class="switch01">
                            <input type="checkbox"
                                   ng-checked="templateI18n.status === 'ACTIVE'"
                                   ng-click="vm.helpers.changeStatus(templateI18n)"
                                   name="switch"
                                   ng-disabled="templateI18n.language === vm.defaultLanguage"
                            >
                            <span>Yes</span>
                        </label>
                        <h2 class="h3">{{ vm.enums.COMPANY_LANGUAGE_ENUM.LABELS[templateI18n.language] }}</h2>

                        <ul class="actions01">
                            <li>
                                <a class="btn view" ng-click="vm.helpers.preview(templateI18n)">
                                    {{ 'notification.Preview e-mail' | translate }}
                                </a>
                            </li>
                            <li ng-if="template.sendIcalFile">
                                <a class="btn view" ng-click="vm.helpers.previewNotification(templateI18n)">
                                    {{ 'notification.Preview notification' | translate }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <form-wrapper>
                        <form-row error="vm.form.errors.templates[index].templateI18ns[templateI18n.language].msgSubject" ng-if="templateI18n.status === 'ACTIVE'">
                            <label class="label">{{ 'notification.E-mail subject' | translate }}*</label>
                            <div class="items">
                                <input ng-model="templateI18n.msgSubject" type="text" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.templates[index].templateI18ns[templateI18n.language].msgBody" ng-if="templateI18n.status === 'ACTIVE'">
                            <label class="label">{{ 'events.Reminder notification' | translate }} *</label>
                            <div class="items">
                                <ng-ckeditor class="mt10" ng-model="templateI18n.msgBody" ng-config="vm.ckconfig"></ng-ckeditor>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.templates[index].templateI18ns[templateI18n.language].calenderContent"
                            ng-if="template.sendIcalFile && templateI18n.status === 'ACTIVE'">
                            <label class="label">{{ 'notification.Calendar invite content' | translate }}</label>
                            <div class="items">
                                <ng-ckeditor class="mt10" ng-model="templateI18n.calenderContent" ng-config="vm.ckconfig"></ng-ckeditor>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </form-wrapper>
                </div>
            </div>
        </div>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/events/partials/detail/default/index.js